import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Clock, Mail, Users } from 'lucide-react';
import { mockData } from '../mock';

const Volunteer = () => {
  const { volunteer, organization } = mockData;

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <section className="bg-gradient-to-b from-mauve-100 to-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <Badge className="bg-amber-500 text-white px-4 py-2 mb-4">
            Coming Soon
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-darkslate-700 mb-4">
            Volunteer Opportunities
          </h1>
          <p className="text-lg text-darkslate-500">
            Help us make a difference in the lives of pets and their families.
          </p>
        </div>
      </section>

      {/* Coming Soon Message */}
      <section className="py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <Card className="border-2 border-olive-300 bg-olive-50">
            <CardHeader>
              <CardTitle className="text-2xl text-darkslate-700 flex items-center gap-2">
                <Clock className="h-6 w-6 text-olive-500" />
                Volunteer Program In Development
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-darkslate-600">
              <p className="text-lg">We're currently building our volunteer program! Check back soon for more opportunities to get involved.</p>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* What We're Looking For */}
      <section className="py-12 px-4 bg-mauve-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-darkslate-700 mb-8">
            What We'll Need from Volunteers
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <Card className="border-2 border-mauve-200">
              <CardHeader>
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-3">
                  <Users className="h-6 w-6 text-red-600" />
                </div>
                <CardTitle className="text-xl text-darkslate-700">Reliable Transportation</CardTitle>
              </CardHeader>
              <CardContent className="text-darkslate-500">
                Volunteers with vehicles to help pick up donations from community members and deliver them to our location.
              </CardContent>
            </Card>

            <Card className="border-2 border-mauve-200">
              <CardHeader>
                <div className="w-12 h-12 bg-olive-100 rounded-lg flex items-center justify-center mb-3">
                  <Clock className="h-6 w-6 text-olive-600" />
                </div>
                <CardTitle className="text-xl text-darkslate-700">Flexible Schedule</CardTitle>
              </CardHeader>
              <CardContent className="text-darkslate-500">
                Ability to coordinate pickup times that work for both you and donors. Most pickups can be scheduled at your convenience.
              </CardContent>
            </Card>

            <Card className="border-2 border-mauve-200">
              <CardHeader>
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-3">
                  <Mail className="h-6 w-6 text-amber-600" />
                </div>
                <CardTitle className="text-xl text-darkslate-700">Good Communication</CardTitle>
              </CardHeader>
              <CardContent className="text-darkslate-500">
                Keep in touch with our team and donors to ensure smooth coordination of donation pickups.
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-darkslate-700 mb-4">
            Interested in Volunteering?
          </h2>
          <p className="text-lg text-darkslate-500 mb-8">
            We'd love to hear from you! Email us to express your interest and we'll keep you updated as our volunteer program develops.
          </p>
          <a 
            href="mailto:kindnesscrew@bitsofkindness.ca?subject=Volunteer Interest"
            className="inline-block bg-olive-500 hover:bg-olive-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
          >
            Email Volunteer Coordinator
          </a>
        </div>
      </section>
    </div>
  );
};

export default Volunteer;
